import {computed, observable} from "mobx";

import {BaseRepository} from "../../../../infrastructure/repositories/base-repository";
import LANGUAGES from '../../../../core/app/consts/languages';
import {LanguageDomainModel} from "../../models/language/language.domain-model";
import {LanguageFactory} from "./language.factory";
import {LanguageApi} from "./language.api";
import {BaseUtilsService} from "../../../../infrastructure/domain-services/base-utils-service";
import {makeObservableClass} from "../../../../infrastructure/decorators/observable";

@makeObservableClass
export class LanguageRepository extends BaseRepository {
  factory: LanguageFactory;
  @observable selectedCultureName: Number;

  static injectables = [...BaseUtilsService.injectables, LanguageApi, LanguageFactory];

  setLanguage(cultureName: String) {
    this.selectedCultureName = cultureName;

    return this.selectedLanguage;
  }

  fetch({ cultureName }) {
    this.setLanguage(cultureName);

    return Promise.resolve(this.selectedLanguage);
  }

  findByCultureName(cultureName: String = this.selectedCultureName) {
    const result: LanguageDomainModel = this.languages.find(((lang) => lang.cultureName?.toLowerCase() === cultureName?.toLowerCase()));

    return result;
  }

  findById(languageId: Number) {
    const result: LanguageDomainModel = this.languages.find((language: LanguageDomainModel) => language.id === languageId);

    return result;
  }

  get languages(): Array<LanguageDomainModel> {
    const languages: Array<LanguageDomainModel> = LANGUAGES.map((lang: LanguageDomainModel) => this.factory.createApiObject(lang));

    return languages;
  }

  @computed get selectedLanguage(): LanguageDomainModel {
    return this.findByCultureName(this.selectedCultureName);
  }
}

